// extracted by mini-css-extract-plugin
export default {"table":"Table_table__iVUPI","cellChipWrapper":"Table_cellChipWrapper__9Bj4d","header":"Table_header__DG0jI","processingRow":"Table_processingRow__+-+bN"};